import Route from '@ember/routing/route';

export default class BoardsRoute extends Route {}
